import { Switch, withRouter } from 'react-router'
import AsyncComponent from 'studiokit-scaffolding-js/lib/components/HOC/AsyncComponent'
import Route from 'studiokit-scaffolding-js/lib/components/SentryRoute'
import CONFIG from '../configuration'

const ErrorScreen = AsyncComponent(() => import('studiokit-scaffolding-js/lib/components/Error'))
const NotFound = AsyncComponent(() => import('studiokit-scaffolding-js/lib/components/NotFound'))
const AccessibilityStatement = AsyncComponent(() => import('./AccessibilityStatement'))
const Downtime = AsyncComponent(() => import('./Downtime'))
const Main = AsyncComponent(() => import('./Main'))

const Routes = () =>
	CONFIG.IS_DOWNTIME ? (
		<Switch>
			<Route component={Downtime} />
		</Switch>
	) : (
		<Switch>
			<Route exact path="/accessibility-statement" component={AccessibilityStatement} />
			<Route exact path="/error" component={ErrorScreen} />
			<Route exact path="/not-found" component={NotFound} />
			<Route exact path="/downtime" component={Downtime} />

			<Route path="/" component={Main} />

			{/* fallback to not found */}
			<Route component={NotFound} />
		</Switch>
	)

const WrappedRoutes = withRouter(Routes)
export default WrappedRoutes
